import {
    LOGIN_OMPLIR_DADES_USUARI_REGISTRAT,
    LOGIN_ESBORRAR_DADES_USUARI_REGISTRAT
} from './actionTypes';

export const loginOmplirDadesUsuariRegistrat = (dadesUsuari) => {
    return {
        type: LOGIN_OMPLIR_DADES_USUARI_REGISTRAT,
        dadesUsuari
    };
};

export const loginEsborrarDadesUsuariRegistrat = () => {
    return {
        type: LOGIN_ESBORRAR_DADES_USUARI_REGISTRAT
    };
};



// WEBPACK FOOTER //
// ./src/actions/login.js